// extracted by mini-css-extract-plugin
export default {"container":"BillingTaxRateDialog_container__FNKLN","label":"BillingTaxRateDialog_label__c+hoS","value":"BillingTaxRateDialog_value__osF84"};